import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import budgit from "../../../images/logos/budgit.png";
import civic from "../../../images/logos/civic.svg";
import oxlade from "../../../images/logos/oxlade.png";
import grap from "../../../images/logos/grap.png";
import linker from "../../../images/logos/linker.png";
import login from "../../../images/logos/login.jpg";
import yvote from "../../../images/logos/yvote.jpg";

const Clients = () => {
  return (
    <Box padding={{ xs: "5% 0%", sm: "5% 0%" }} width={"100%"}>
      <Box>
        <Typography
          variant="h4"
          color="#33E68C"
          fontWeight={800}
          paddingBottom={"1%"}
          textAlign={"left"}
        >
          <Typography
            component={"span"}
            color="#000"
            fontWeight={800}
            variant={"h4"}
          >
            Our {""}
          </Typography>
          Clients
        </Typography>
      </Box>
      <Box
        display={"flex"}
        justifyContent={"space-between"}
        alignItems={"center"}
        flexWrap={"wrap"}
        width={{ xs: "100%", sm: "100%" }}
        padding={{ xs: "5% 0%", sm: "2% 0%" }}
        marginLeft={{ xs: "0%", sm: "0%" }}
        data-aos={"fade-down"}
      >
        <Box
          component="img"
          height={{ xs: "8vh", sm: "7vh" }}
          width={{ xs: "45%", sm: "11%" }}
          data-aos={"fade-up"}
          sx={{
            filter: "grayscale(100%)",
            "&:hover": {
              cursor: "pointer",
              filter: "grayscale(0%)",
            },
          }}
          src={budgit}
          alt={"budgit_logo"}
        />
        <Box
          component="img"
          height={{ xs: "4vh", sm: "7vh" }}
          width={{ xs: "45%", sm: "15%" }}
          data-aos={"fade-up"}
          sx={{
            filter: "grayscale(100%)",
            "&:hover": {
              cursor: "pointer",
              filter: "grayscale(0%)",
            },
          }}
          src={civic}
          alt={"civicHive_logo"}
        />
        <Box
          component="img"
          height={{ xs: "10vh", sm: "11vh" }}
          width={{ xs: "45%", sm: "14%" }}
          marginTop={{ xs: "5%", sm: "0%" }}
          data-aos={"fade-up"}
          sx={{
            opacity: 0.5,
            backgroundColor: "#000",
            filter: "grayscale(100%)",
            "&:hover": {
              opacity: 1,
              backgroundColor: "#000",
              cursor: "pointer",
              filter: "grayscale(0%)",
            },
          }}
          src={oxlade}
          alt={"oxlade_consulting"}
        />
        <Box
          component="img"
          height={{ xs: "9vh", sm: "11vh" }}
          width={{ xs: "35%", sm: "10%" }}
          marginTop={{ xs: "5%", sm: "0%" }}
          data-aos={"fade-up"}
          sx={{
            filter: "grayscale(100%)",
            "&:hover": {
              cursor: "pointer",
              filter: "grayscale(0%)",
            },
          }}
          src={grap}
          alt={"GRAP"}
        />

        <Box
          component="img"
          height={{ xs: "6vh", sm: "6vh" }}
          width={{ xs: "40%", sm: "10%" }}
          marginTop={{ xs: "5%", sm: "0%" }}
          data-aos={"fade-up"}
          sx={{
            filter: "grayscale(100%)",
            "&:hover": {
              cursor: "pointer",
              filter: "grayscale(0%)",
            },
          }}
          src={linker}
          alt={"Linker"}
        />
        <Box
          component="img"
          height={{ xs: "7vh", sm: "7vh" }}
          width={{ xs: "45%", sm: "11%" }}
          marginTop={{ xs: "5%", sm: "0%" }}
          data-aos={"fade-up"}
          sx={{
            filter: "grayscale(100%)",
            "&:hover": {
              cursor: "pointer",
              filter: "grayscale(0%)",
            },
          }}
          src={login}
          alt={"LOGIN"}
        />
        <Box
          component="img"
          height={{ xs: "10vh", sm: "10vh" }}
          width={{ xs: "45%", sm: "12%" }}
          marginTop={{ xs: "5%", sm: "0%" }}
          data-aos={"fade-up"}
          sx={{
            filter: "grayscale(100%)",
            "&:hover": {
              cursor: "pointer",
              filter: "grayscale(0%)",
            },
          }}
          src={yvote}
          alt={"YVoteNaija"}
        />
      </Box>
    </Box>
  );
};

export default Clients;
